import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({

  prefix: '/cms',

  routes: [
    Route('/home', 'cms.home', view('cms/Home')),
    Route('/pages', 'cms.pages', view('cms/Pages')),
    Route('/page/create', 'cms.newPage', view('cms/NewPage')),
    Route('/page/:page/edit', 'cms.editPage', view('cms/EditPage')),
    Route('/galleries', 'cms.galleries', view('cms/Galleries')),
    Route('/gallery/create', 'cms.newGallery', view('cms/NewGallery')),
    Route('/gallery/:gallery/edit', 'cms.editGallery', view('cms/EditGallery')),
  ]
})